import { useSearchModel } from "../search-model";
import { useViewData } from "../view-data";
import { useFilteredQueryDataBySearchModel } from "./use-filtered-query-data-by-search-model";
import { useSearchReservationRequestList } from "./use-search-reservation-request-list";

type Props = {
	hotelID: string;
};

export const useInitialized = ({ hotelID }: Props) => {
	const {
		queryData,
		// 予約の検索
		onSearchReservationRequestList,
	} = useSearchReservationRequestList({ hotelID });

	/**
	 * SearchModel の生成
	 */
	const {
		//
		searchModel,
		//
		// 詳細検索のメルマガ配信希望者フラグの変更
		onChangeIsAcceptMailMagazineChecked,
		// 詳細検索の現地決済者フラグの変更
		onChangeIsLocalPaymentChecked,
	} = useSearchModel();

	/**
	 * SearchModel をもとに QueryData をフィルタリングする
	 */
	const { queryData: filteredQueryData } = useFilteredQueryDataBySearchModel({ queryData, searchModel });

	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({ queryData, filteredQueryData });

	return {
		//
		// readonly
		viewData,
		//
		// searchable
		searchModel,
		// 予約の検索
		onSearchReservationRequestList,
		// 詳細検索のメルマガ配信希望者フラグの変更
		onChangeIsAcceptMailMagazineChecked,
		// 詳細検索の現地決済者フラグの変更
		onChangeIsLocalPaymentChecked,
	};
};
